import _ from 'lodash';

export const StorageModes = [
  'memory',
  'localStorage',
  'sessionStorage'
];

export const StorageDefaults = {
  storageMode: StorageModes[1] // localStorage
};

/**
 * Wrapper for the angular-cache implementation
 * (@see https://github.com/jmdobry/angular-cache)
 * @param {Object} CacheFactory
 */
export const CacheFactoryWrapper = function(CacheFactory) {
  'ngInject';

  const create = (cacheId, options = {}) => {
    if (!CacheFactory.get(cacheId)) {
      return CacheFactory.createCache(
        cacheId,
        _.defaults(options, StorageDefaults)
      );
    }
    return CacheFactory.get(cacheId);
  };

  const get = (cacheId) => {
    return CacheFactory.get(cacheId);
  };

  return {
    create,
    get,
    clearAll: CacheFactory.clearAll,
    destroyAll: CacheFactory.destroyAll
  };
}
